(() => {
  const root = document.querySelector('[data-mz-xmas-effects]');
  if (!root) return;

  const snow = root.querySelector('[data-mz-xmas-snow]');
  const buttons = [...root.querySelectorAll('[data-mz-xmas-level]')];
  const status = root.querySelector('[data-mz-xmas-status]');
  const storageKey = 'mz-christmas-snow-level-v1';
  const levels = ['off', 'normal', 'much'];
  const labels = { off: 'Fra', normal: 'Normal', much: 'Meget' };
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  let saved;
  try {
    saved = localStorage.getItem(storageKey);
  } catch {}

  if (saved === 'light') saved = 'normal';

  function setLevel(level) {
    if (!levels.includes(level)) return;

    root.dataset.motion = level === 'off' ? 'off' : 'on';
    snow.dataset.level = level;

    const count = level === 'much' ? 24 : 16;
    const duration = level === 'much' ? 12 / 1.1 : 12;

    root.querySelectorAll('.mz-xmas-snow__zone').forEach(zone => {
      zone.querySelectorAll('.mz-xmas-snow__flake').forEach((flake, i) => {
        flake.style.display = i < count ? 'block' : 'none';
        if (i % 2 === 0) {
  const fraction = (i + 1) / count;

  flake.style.left = zone.classList.contains(
    'mz-xmas-snow__zone--right'
  )
    ? `calc(100% - var(--mz-snow-side) * ${fraction} - 10px)`
    : `calc(var(--mz-snow-side) * ${fraction} - 10px)`;
} else {
  flake.style.left = '';
}
        flake.style.animationDuration = `${duration}s`;
        const phaseIndex = (i * 5) % count;
        const zoneOffset = zone.classList.contains(
          'mz-xmas-snow__zone--right'
        ) ? 0.5 : 0;

        flake.style.animationDelay =
          `-${((phaseIndex + zoneOffset) / count) * duration}s`;
      });
    });

    buttons.forEach(button => {
      button.setAttribute(
        'aria-pressed',
        String(button.dataset.mzXmasLevel === level)
      );
    });

    if (status) status.textContent = `Sne: ${labels[level]}.`;

    try {
      localStorage.setItem(storageKey, level);
    } catch {}
  }

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      setLevel(button.dataset.mzXmasLevel);
    });
  });

  setLevel(
    levels.includes(saved) ? saved : (reducedMotion ? 'off' : 'normal')
  );
    const header = document.querySelector('store-header');
  const control = root.querySelector('[data-mz-xmas-control]');
  const storeTrigger = document.querySelector('store-selector-trigger');
  const mobileControl = window.matchMedia('(max-width: 749px)');
  let snowFramePending = false;

  function updateControlPosition() {
    if (!control) return;
    const rect = storeTrigger?.getBoundingClientRect();
    if (mobileControl.matches && rect && rect.width > 0 && rect.height > 0 && rect.top > 0 && rect.top < window.innerHeight) {
      control.style.setProperty('--mz-control-right', `${Math.max(12, window.innerWidth - rect.right)}px`);
      control.style.setProperty('--mz-control-bottom', `${Math.max(12, window.innerHeight - rect.top + 10)}px`);
    } else {
      control.style.removeProperty('--mz-control-right');
      control.style.removeProperty('--mz-control-bottom');
    }
  }

  function updateSnowBoundary() {
    if (header) {
      const bottom = Math.max(
        0,
        Math.min(window.innerHeight, header.getBoundingClientRect().bottom)
      );

      snow.style.setProperty('--mz-snow-header-bottom', `${bottom}px`);
    }

    updateControlPosition();
    snowFramePending = false;
  }

  function scheduleSnowBoundary() {
    if (snowFramePending) return;
    snowFramePending = true;
    requestAnimationFrame(updateSnowBoundary);
  }

  window.addEventListener('scroll', scheduleSnowBoundary, { passive: true });
  window.addEventListener('resize', scheduleSnowBoundary);
  if (storeTrigger) {
    new ResizeObserver(scheduleSnowBoundary).observe(storeTrigger);
    new MutationObserver(scheduleSnowBoundary).observe(storeTrigger, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
  }
  const stickyPanel = document.querySelector('.sticky-atc-panel');
  if (stickyPanel) new MutationObserver(scheduleSnowBoundary).observe(stickyPanel, { attributes: true, attributeFilter: ['class', 'style'] });
  window.visualViewport?.addEventListener('resize', scheduleSnowBoundary);
  updateSnowBoundary();
})();